export const apiField = 's5_roof_panel';

const makeOptions = data => data.map(item => typeof item === 'object' ? item : ({ value: item, name: item }));


function makeConfig(data: string[]) {
  return {
    label: 's5RoofPanel',
    type: 'Select',
    apiField,
    missing: undefined,
    tooltip: undefined,
    data: data.map(item => ({ value: item, name: item })),
  };
}



export default function s5RoofPanel(filteredpanelTypeValues: string[]) {
  return makeConfig(filteredpanelTypeValues);
}
